/* src/app/forms/produtos/mercadolivre/meli-mlb-download/meli-task-processor/meli-task-processor.component.scss */
.content {
  height: 400px;
  width: 100%;
  display: flex;
  padding: 10px;
  flex-direction: column;
}
.text-content {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
textarea {
  height: 100% !important;
  overflow: auto;
  width: 100%;
  resize: none;
  font-size: var(--tem-fs-sm, 10px);
}
.pb-content {
  margin-top: 10px;
  margin-bottom: 10px;
}
.button-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.spacer {
  flex: 1;
}
/*# sourceMappingURL=meli-task-processor.component.css.map */
